import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  const orderKey = to.query.key;
  
  if (!orderKey || typeof orderKey !== 'string') {
    return navigateTo('/cart');
  }
});
